export default {
  data() {
    return {
      showPhoneInfo: false,
      // 是否显示租赁热线信息框
      showWechatInfo: false,
      // 是否显示企业微信信息框
      phoneInfoPosition: {
        top: '0px',
        left: '0px'
      },
      // 租赁热线信息框的位置
      wechatInfoPosition: {
        top: '0px',
        left: '0px'
      },
      // 企业微信信息框的位置
      hideTimer: null // 控制隐藏的定时器
    };
  },
  mounted() {
    // 添加全局点击事件监听，点击菜单外的区域时隐藏信息框
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
    this.clearHideTimer();
  },
  methods: {
    // 更新信息框位置的方法
    updateInfoPosition(type, event) {
      this.clearHideTimer(); // 清除隐藏定时器，防止闪烁

      const menuItem = event.currentTarget;
      const rect = menuItem.getBoundingClientRect();
      if (type === 'phone') {
        this.phoneInfoPosition = {
          top: `${rect.top}px`,
          left: `${rect.left - 271}px` // 移动到图标左侧
        };
        this.showPhoneInfo = true;
        this.showWechatInfo = false;
      } else if (type === 'wechat') {
        this.wechatInfoPosition = {
          top: `${rect.top}px`,
          left: `${rect.left - 160}px`
        };
        this.showWechatInfo = true;
        this.showPhoneInfo = false;
      }
    },
    // 延迟隐藏信息框的方法
    startHideTimer(type) {
      this.hideTimer = setTimeout(() => {
        if (type === 'phone') this.showPhoneInfo = false;
        if (type === 'wechat') this.showWechatInfo = false;
      }, 300);
    },
    // 清除隐藏定时器
    clearHideTimer() {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
    },
    // 处理点击留言图标的方法
    handleMessage() {
      window.open('https://affim.baidu.com/unique_54674045/chat?siteId=21738119&userId=54674045&siteToken=699c009a5e0bc944d213e6ba7421d981', '_blank');
    },
    // 平滑滚动回到顶部
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    // 点击菜单区域外时隐藏所有信息框
    handleClickOutside(event) {
      const isClickInside = event.target.closest('.float-menu') || event.target.closest('.info-box');
      if (!isClickInside) {
        this.showPhoneInfo = false;
        this.showWechatInfo = false;
      }
    }
  }
};